import { Component } from '@angular/core';
import packageInfo from '../../package.json';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'client';
  ngOnInit() {
    console.log('UI version:', packageInfo.dependencies["@tbg/ui-components"]);
  }
}
